import styled from 'styled-components';
import { StyledPageHeader } from '../../components/PageHeader'

const MapPopup = styled.div`
  position: fixed;
  left: 0;
  z-index: 3;

  width: 100%;
  height: 100vh;
  
  background: #ffffff;
`;

const Body = styled.div`
  height: calc(100vh - 64px);

  overflow: auto;
  padding: 32px;


  .ms-Checkbox.is-checked {
    .ms-Checkbox-checkbox {
      background: ${({theme}) => theme.colors.lightBlue};
    } 
  }
`;

export const Styled = {
  MapPopup,
  Body,
};
